import { Button, EfModal, message } from '@/components/UI';
import { NoDataIcon } from '@/components/UI/svg/Ecocredits';
import { rewardRedeemDiscounCoupon } from '@/service';
import { copyText } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { getLang } from 'lowcomp/plugins/member/utils';
import React from 'react';
import { TextLang } from '../../TextLang';
// import Coupon from '../Coupon2';
import Coupon from 'lowcomp/plugins/member/member-redeem/content/Coupon2';
import NoteModal from '../ModalComp/NoteModal';
import css from './index.module.scss';

interface Props {
    visible: boolean;
    setShowPage: (modal: string) => void;
    coupons: any[];
    isNeedValidate?: boolean;
    refershData: () => void;
}

const GrabEcoCreditsBonus: React.FC<Props> = ({ setShowPage, visible, coupons = [], refershData, isNeedValidate = false }) => {
    const { useEffect, useState, useRouter, useLang, isMobile } = useGlobal();
    const router = useRouter();
    const { locale } = router;
    //const { t } = useLang('ecocredits');
    const t = getLang(TextLang, locale);

    const [currCoupon, setCurrCoupon] = useState();
    const [currNotes, setCurrNotes] = useState(null);

    // 对一些discountId做一些特殊处理
    const linkMap: { [k: string]: string } = {
        '1635227277057232898': `/${locale}/ecocredits-day`,
        '1638383549539569666': 'https://us.ecoflow.com/products/outdoor-kit',
        '1638384706130059266': 'https://us.ecoflow.com/products/river-2-pro-portable-power-station',
        '1638385215599583234': 'https://us.ecoflow.com/products/delta-pro-portable-power-station',
        '1638386232449867777': 'https://ca.ecoflow.com/products/outdoor-kit',
        '1638386872819425281': 'https://ca.ecoflow.com/products/river-2-pro-portable-power-station',
        '1638387248596930562': 'https://ca.ecoflow.com/products/delta-pro-portable-power-station',
    };

    const onReedem = async (coupon: any) => {
        const { campaignId, campaignVersion, couponId, discountId, discountVersion } = coupon;
        let params: any = {};

        if (couponId) {
            params = { couponId };
        } else {
            params = {
                campaignId,
                campaignVersion,
                discountId,
                discountVersion,
            };
        }

        const res = await rewardRedeemDiscounCoupon(params, locale);
        if (res?.code === '0') {
            copyText(res?.data?.coupon);
            const resCoupon = { picUrl: coupon?.picUrl, discountId: coupon?.discountId, ...res?.data };
            setCurrCoupon(resCoupon);
            refershData();
            return;
        }
        // 前端页面长时间不刷新，导致兑换规则落后后端版本
        if (res?.code === '2422') {
            message.error(t('stay_too_long') || res?.message);
            return;
        }

        // 兑换次数超出上限
        if (res?.code === '2423') {
            message.error(t('exceeded_counts') || res?.message);
            return;
        }

        // 前端页面长时间不刷新，导致优惠券规则超过截止时间
        if (res?.code === '2424') {
            message.error(t('stay_too_long') || res?.message);
            return;
        }

        // 不允许兑换 plus会员
        if (res?.code === '2475') {
            message.error(t('only_plus_member') || res?.message);
            return;
        }

        // 不允许兑换 普通会员
        if (res?.code === '2476') {
            message.error(t('only_member') || res?.message);
            return;
        }

        // 需求改成不提示
        // message.error(res?.message || 'NetWork Error');
    };

    const onRules = (notes: any) => {
        setCurrNotes(notes);
    };

    const goShopify = (coupon: any) => {
        const { discountId, jumpUrl } = coupon || {};

        let href: string | undefined = linkMap[discountId];
        // 读取配置的url
        if (jumpUrl) href = jumpUrl;

        if (href) {
            if (href.startsWith('http')) {
                setTimeout(() => window.open(href, '_blank'));
            } else {
                window.location.href = href;
            }
            return;
        }
        if (isMobile) {
            window.location.href = `https://${locale}.ecoflow.com`;
            return;
        }
        setTimeout(() => {
            window.open(`https://${locale}.ecoflow.com`, '_blank');
        });
    };

    useEffect(() => {
        if (!visible) {
            currCoupon(undefined);
            setCurrNotes(undefined);
        }
    }, [visible]);

    return (
        <>
            <div className={css.grab_ecocredits_bonus}>
                <h4 className="bonus_title">{t('grab_title')}</h4>
                <h5 className="bonus_sub_title">{t('grab_sub_title')}</h5>

                <div className={`bonus_coupon_list ${coupons.length ? '' : 'no-content'}`}>
                    {coupons?.map((coupon: any) => (
                        <Coupon
                            key={coupon.id}
                            className="coupon_item"
                            btnText={t('grab_btn_text')}
                            disabled={coupon?.receiveStatus && coupon?.receiveStatus !== 1}
                            coupon={{ ...coupon }}
                            onReedem={onReedem}
                            onViewsRules={onRules}
                            couponModal={true}
                            isNeedValidate={isNeedValidate}
                        />
                    ))}
                    {!coupons.length && (
                        <div className="no-content">
                            <div className="no-content-icon">
                                <NoDataIcon />
                            </div>
                            <p className="no-content-note">{t('no-grab-content-note')}</p>
                        </div>
                    )}
                </div>
            </div>
            <EfModal className={`${css.efmodal} coupon`} visible={!!currCoupon} onCancel={() => setCurrCoupon(undefined)} zIndex={999999}>
                <h5 className="title">{t('grab_success_title')}</h5>
                <Coupon className="coupon_card" coupon={currCoupon} hideBtn hideNote />
                <p className="m-desc">
                    {t('grab_success_text1')}
                    <br />
                    {t.rich('grab_success_text2', {
                        code: (children: string) => (
                            <i
                                className="btn"
                                onClick={() => {
                                    setShowPage('coupon_modal');
                                    setCurrCoupon(undefined);
                                }}
                            >
                                {children}
                            </i>
                        ),
                    })}
                </p>
                <Button onClick={() => goShopify(currCoupon)} className="m-btn">
                    {t('store')}
                </Button>
            </EfModal>
            {/* 优惠券rules弹框 */}
            <NoteModal currNotes={currNotes} setCurrNotes={setCurrNotes} disabledCoupon={currNotes?.receiveStatus && currNotes?.receiveStatus !== 1} />
        </>
    );
};

export default GrabEcoCreditsBonus;
